import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import TagManager from 'react-gtm-module';

const GTMPageTracker = () => {
    const location = useLocation();
    useEffect(() => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'pageview',
                pagePath: location.pathname + location.search,
            },
        });
    }, [location]);
    
    return null;
};

export default GTMPageTracker;